export const lounge = 'lounge'
export const lounge1000 = 'lounge1000'
export const lounge10000 = 'lounge10000'
export const myfreecams = 'myfreecams'
export const myfreecams_news = 'myfreecams_news'

export const Lounge = 'Lounge'
export const Lounge1000 = 'Lounge1000'
export const Lounge10000 = 'Lounge10000'
export const MyFreeCams = 'MyFreeCams'
export const MyFreeCams_News = 'MyFreeCams_News'

export const mfcAccountsSlugToUID = {
    [myfreecams]: 37512,
    [myfreecams_news]: 481462,
    [lounge]: 486121,
    [lounge1000]: 486123,
    [lounge10000]: 486124,
} as const

export const mfcAccountsUIDtoSlug = {
    37512: myfreecams,
    481462: myfreecams_news,
    486124: lounge10000,
    486123: lounge1000,
    486121: lounge,
} as const

export const loungeSlugs = [lounge, lounge1000, lounge10000] as const

export const loungeUIDs = [
    mfcAccountsSlugToUID.lounge,
    mfcAccountsSlugToUID.lounge1000,
    mfcAccountsSlugToUID.lounge10000,
] as const
